<template>
    <v-container>
        <form slot="leftContainer" autocomplete="nope" data-vv-scope="form-2" @submit.prevent="addInventary('form-2')">
            <v-card>
                <v-card-title class="grey lighten-4">
                    <b>Inventario</b>
                </v-card-title>
                <v-card-text class="pa-4">
                    <v-row dense align="center">
                        <v-col cols="12" sm="3">
                            <v-menu
                                dense
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        v-model="form.operation_date"
                                        label="Fecha de Operación"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-validate="'required'"
                                        data-vv-name="form.operation_date"
                                        data-vv-as="Fecha de Operación"
                                        :error-messages="errors.collect('form.operation_date')"
                                        v-on="on"
                                    />
                                </template>

                                <v-date-picker dense v-model="form.operation_date" no-title locale="es" @input="menu2 = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                v-validate="'required'"
                                dense
                                v-model="form.types"
                                :items="listTypes"
                                item-text="text"
                                placeholder="INN"
                                item-value="id"
                                :error-messages="errors.collect('form.types')"
                                label="Motivo"
                                data-vv-name="form.types"
                                data-vv-as="Tipo"
                                filled
                                rounded
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-autocomplete
                                v-validate="'required'"
                                dense
                                v-model="form.warehouse_id"
                                :items="custom_warehouses"
                                item-text="description"
                                item-value="id"
                                :error-messages="errors.collect('form.warehouse_id')"
                                label="ALMACEN AFECTADO"
                                data-vv-name="form.warehouse_id"
                                data-vv-as="Tipo"
                                filled
                                rounded
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field
                                dense
                                v-model="form.oT"
                                v-validate="'required'"
                                data-vv-name="form.oT"
                                data-vv-as="Orden De Trabajo"
                                :error-messages="errors.collect('form.oT')"
                                label="Orden De Trabajo / Guia De Remision"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field
                                dense
                                v-model="form.numTicket"
                                v-validate="'required'"
                                data-vv-name="form.numTicket"
                                data-vv-as="Ticket / Factura"
                                :error-messages="errors.collect('form.numTicket')"
                                label="Ticket / Factura Compra"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                v-validate="'required'"
                                dense
                                v-model="form.numArea"
                                :items="custom_Area"
                                data-vv-name="form.numArea"
                                data-vv-as="Area"
                                :error-messages="errors.collect('form.numArea')"
                                label="Area"
                                filled
                                rounded
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field
                                dense
                                v-model="form.project"
                                v-validate="'required'"
                                data-vv-name="form.project"
                                data-vv-as="Proyecto"
                                :error-messages="errors.collect('form.project')"
                                label="Proyecto"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field
                                dense
                                v-model="form.provider"
                                v-validate="'required'"
                                data-vv-name="form.provider"
                                data-vv-as="Cliente o Proveedor"
                                :error-messages="errors.collect('form.provider')"
                                label="Cliente o Proveedor"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                dense
                                v-model="form.nameAuthorized"
                                :items="listaUser"
                                item-text="nombres"
                                item-value="nombres"
                                v-validate="'required'"
                                data-vv-name="form.nameAuthorized"
                                data-vv-as="Empleado Entrega"
                                :error-messages="errors.collect('form.nameAuthorized')"
                                label="EMPLEADO ENTREGA"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                dense
                                v-model="form.nameReception"
                                :items="listaUser"
                                item-text="nombres"
                                item-value="nombres"
                                v-validate="'required'"
                                data-vv-name="form.nameReception"
                                data-vv-as="Empleado Recibe"
                                :error-messages="errors.collect('form.nameReception')"
                                label="Empleado Recibe"
                            />
                        </v-col>

                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                v-validate="'required'"
                                dense
                                v-model="form.categories"
                                :items="listCategories"
                                item-text="text"
                                placeholder="INN"
                                item-value="id"
                                :error-messages="errors.collect('form.categories')"
                                label="Categoria"
                                data-vv-name="form.categories"
                                data-vv-as="Tipo"
                                filled
                                rounded
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-textarea
                                v-model="form.observations"
                                data-vv-name="form.observations"
                                label="Observaciones"
                            />
                        </v-col>

                        <!-- <v-col cols="12" sm="2">
                            <v-text-field
                                dense
                                data-vv-name="form.tipoCambio"
                                data-vv-as="form.tipoCambio"
                                v-model="form.tipoCambio"
                                label="Tipo Cambio"
                                @keypress="isNumber"
                            />
                        </v-col> -->
                        <SelectProductos items="true"></SelectProductos>
                    </v-row>

                    <v-col cols="12" sm="6" class="mt-2 align-right">
                        <v-btn type="submit" large :loading="loading" dark block>
                            <b>{{ 'AGREGAR TRANSACCIÓN' }}</b>
                        </v-btn>
                    </v-col>
                </v-card-text>
            </v-card>
        </form>
        <v-card-title class="grey lighten-4 mt-5">
            <v-row dense>
                <v-col cols="12" sm="5">
                    <b>LISTA DE STOCK</b> |
                    <a href="#" @click.prevent="$router.push('/logistica/inventary/list')"
                        >Ver Transacciones
                        <v-icon>mdi-link</v-icon>
                    </a>
                </v-col>
                <v-col cols="12" sm="1"> </v-col>
                <v-col cols="12" sm="3"> <v-text-field dense v-model="search" append-icon="mdi-magnify" label="BUSCAR" single-line hide-details /> </v-col>

                <v-col cols="12" sm="3">
                    <v-btn class="mx-1" small color="primary" dark block @click="downloadHandle">
                        DESCARGAR <v-icon right dark> mdi-arrow-down-box </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text class="white pa-2">
            <v-row dense>
                <v-col cols="12">
                    <v-data-table
                        multi-sort
                        :search="search"
                        :headers="headers"
                        :items="_listInventory"
                        :loading="loading2"
                        class="elevation-1"
                        :items-per-page="20"
                    >
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-container>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { mixins } from '@/mixins/mixin.js'
import DefaultForm from '@/utils/defaultForm'
import { exportXLSX } from '@/utils/genericUtils'
import SelectProductos from '@/components/selects/SelectProductInventary'

export default {
    components: {
        SelectProductos
    },
    mixins: [mixins],
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            menu2: false,
            loading: false,
            search: null,
            form: DefaultForm.formInventary(),
            openModalProveedor: false,
            loading2: false,
            listTypes: [
                { id: 'INN', text: 'ENTRADA' },
                { id: 'OUT', text: 'SALIDA' }
            ],
            custom_Area: ['ENSAMBLAJE', 'EQUIPAMIENTO', 'PRODUCCION', 'COMPRAS', 'SOLDADURA', 'CARPINTERIA', 'SERVICIO', 'VENTA'],
            listCategories: [
                { id: 'VENTA', text: 'VENTA' },
                { id: 'INSUMO', text: 'INSUMO' },
                { id: 'VENTA/INSUMO', text: 'VENTA/INSUMO' }
            ],
            headers: [
                { text: 'CÓD Interno', value: 'internal_id' },
                { text: 'Producto', value: 'description' },

                { text: 'Ubicacion', value: 'warehouse' },
                { text: 'CANT', value: 'stock' },
                { text: 'MONEDA', value: 'currency_type_id' },

                { text: 'PRECIO VENTA', value: 'sale_unit_price' },
                { text: 'CATEGORIA', value: 'category' }
            ]
        }
    },
    computed: {
        ...mapState('users', ['user', 'listaUser']),
        ...mapState('sedes', ['custom_warehouses', 'departamentos', 'provincias', 'distritos']),
        ...mapState('inventario', ['listInventory', 'inventory']),
        _listInventory() {
            // Primero filtramos solo los inventarios de warehouses habilitados
            const enabledWarehouseIds = this.custom_warehouses.filter((x) => x.active).map((w) => w.id)
            console.log('enabledWarehouseIds', enabledWarehouseIds)
            return this.listInventory
                .filter((x) => enabledWarehouseIds.includes(x.warehouse_id)) // warehouses habilitados
                .filter((x) => Number(x.stock) > 0) // stock mayor a 0
                .map((x) => ({
                    ...x,
                    warehouse: this.custom_warehouses.find((y) => y.id == x.warehouse_id)?.description || ''
                }))
        }
    },
    methods: {
        ...mapActions({
            getCustomWarehouses: 'sedes/getCustomWarehouses'
        }),

        ...mapActions({
            getItemInventory: 'inventario/getItemInventory',
            getLista: 'users/getLista'
        }),
        ...mapMutations({
            /*             RESET_FORM: 'clientes/RESET_FORM',
            UPDATE_DATOS: 'clientes/UPDATE_DATOS', */
            OPEN_MODAL: 'mainUI/OPEN_MODAL',
            OPEN_BAR: 'mainUI/OPEN_BAR'
        }),
        async addInventary(name) {
            console.log('this.$validator', this.$validator)
            this.$validator
                .validateAll(name)
                .then(async (result) => {
                    console.log('result', result)
                    let text = 'Agregando Inventario'
                    if (result && this.inventory.length > 0) {
                        console.log('this.inventory', this.inventory)

                        try {
                            this.loading = true
                            this.$store.commit('mainUI/OPEN_MODAL', {
                                state: true,
                                text
                            })
                            // Resolver id desde internal_id para items que no lo tengan
                            const idSede = this.$store.state.users.user.idSede
                            const resolvedInventory = await Promise.all(
                                this.inventory.map(async (x) => {
                                    if (x.id) return x
                                    if (!x.internal_id) return x
                                    try {
                                        const results = await this.$store.dispatch('productos/searchProductos', {
                                            text: x.internal_id,
                                            idSede,
                                            showInternals: true
                                        })
                                        const match = results.find(p => p.internal_id === x.internal_id)
                                        if (match) return { ...x, id: match.id }
                                    } catch (e) { /* sin id, se queda sin id */ }
                                    return x
                                })
                            )

                            const data = {
                                types: this.form.types,
                                operation_date: this.form.operation_date,
                                warehouse_id: this.form.warehouse_id,
                                numTicket: this.form.numTicket,
                                observations: [this.form.observations, this.buildObservacionContext()].filter(Boolean).join(' | '),
                                categories: this.form.categories,
                                numArea: this.form.numArea,
                                project: this.form.project,
                                provider: this.form.provider,
                                nameAuthorized: this.form.nameAuthorized,
                                nameReception: this.form.nameReception,
                                oT: this.form.oT,
                                products: JSON.stringify(
                                    resolvedInventory.map((x) => {
                                        return {
                                            id: x.id,
                                            internal_id: x.internal_id,
                                            quantity: x.quantity,
                                            name: x.name || x.description
                                        }
                                    })
                                )
                            }
                            console.log('datatransaction', data)

                            const result = await this.$store.dispatch('inventario/postItemAddInventory', data)
                            console.log('postItemAddInventory', result)
                            this.loading = false
                            if (result.status == 200) {
                                const dataInventory = {
                                    ...data,
                                    idColaborador: this.listaUser.find((x) => x.nombres == data.nameReception).id,
                                    transactionId: result.data.transactionId || result.data.id,
                                    correlative: result.data.correlative,
                                    types: this.listTypes.find((x) => x.id == data.types).text,
                                    warehouse: this.custom_warehouses.find((x) => x.id == data.warehouse_id).description,
                                    project: `${data.project} | PROVEEDOR: ${data.provider}`
                                }
                                await this.$store.dispatch('reporte/reportInventory', dataInventory)
                                this.form = DefaultForm.formInventary()
                                this.$store.commit('inventario/UPDATE_LISTA_INVENTORY', [])

                                // Limpiar query params solo después de éxito
                                if (this.$route.query.fromOrdenEquipamiento) {
                                    this.$router.replace({ path: '/logistica/inventary' })
                                }

                                this.loading2 = true
                                await this.getItemInventory()
                                this.loading2 = false
                            } else {
                                if (result.code === 'INSUFFICIENT_STOCK' && result.data?.items?.length) {
                                    const itemLines = result.data.items
                                        .map((x) => `• [${x.internal_id}] ${x.name}: solicitado ${x.required}, disponible ${x.available}`)
                                        .join('\n')
                                    this.$store.commit('mainUI/OPEN_BAR', {
                                        state: true,
                                        text: `Stock insuficiente:\n${itemLines}`,
                                        color: 'deep-orange darken-1',
                                        timeout: 8000
                                    })
                                } else if (result.code === 'DUPLICATE_TRANSACTION') {
                                    this.$store.commit('mainUI/OPEN_BAR', {
                                        state: true,
                                        text: result.message || 'Ya existe una transacción para esta Orden de Trabajo en este almacén.',
                                        color: 'amber darken-2',
                                        timeout: 8000
                                    })
                                } else {
                                    this.$store.commit('mainUI/OPEN_BAR', {
                                        state: true,
                                        text: result.message || 'Error al procesar la transacción.',
                                        color: 'pink'
                                    })
                                }
                            }
                            this.$store.commit('mainUI/OPEN_MODAL', {
                                state: false,
                                text
                            })
                        } catch (error) {
                            console.error('err-> ', error)
                            this.$store.commit('mainUI/OPEN_BAR', {
                                state: true,
                                text: error?.message || 'Ha ocurrido un error inesperado.',
                                color: 'pink'
                            })
                            this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                        }
                    } else {
                        this.$store.commit('mainUI/OPEN_BAR', {
                            state: true,
                            text: 'Hay Errores',
                            color: 'pink'
                        })
                    }
                    this.$store.commit('mainUI/OPEN_MODAL', {
                        state: false
                    })
                })
                .catch((e) => {
                    //console.log('Eerr ', e)
                    this.loading = false
                })
        },

        buildObservacionContext() {
            const user = this.$store.state.users.user || {}
            const bussines = (this.$store.state.bussines?.listaBussines || []).find((b) => b.id == user.idBussines)
            const empresa = bussines?.shortName || bussines?.name || ''
            const usuario = [user.nombres, user.apellidos].filter(Boolean).join(' ')
            const partes = []
            if (empresa) partes.push(`EMPRESA: ${empresa}`)
            partes.push(`IDBUSINESS: ${user.idBussines}`)
            partes.push(`IDSEDE: ${user.idSede}`)
            if (usuario) partes.push(`USUARIO: ${usuario}`)
            return partes.join(' | ')
        },

        downloadHandle() {
            this.loading = true
            const headers = ['item_id', 'internal_id', 'description', 'warehouse', 'stock', 'currency_type_id', 'sale_unit_price', 'category']
            const filename = `REPORT_INVENTARY_${Date.now()}`

            exportXLSX({ headers, campos: headers, arrayData: this._listInventory }, { filename })
            this.loading = false
        },

        fillFromOrdenEquipamiento() {
            const q = this.$route.query
            if (!q.fromOrdenEquipamiento) return

            // Leer payload desde sessionStorage (evita truncamiento de URL)
            let payload = null
            try {
                const raw = sessionStorage.getItem('ordenEquipamientoPayload')
                if (raw) {
                    payload = JSON.parse(raw)
                    sessionStorage.removeItem('ordenEquipamientoPayload')
                }
            } catch (e) {
                console.error('Error leyendo payload de sessionStorage:', e)
            }

            // Fallback a query params si no hay payload en sessionStorage
            const ordenId = payload?.ordenId || q.ordenId || ''
            const vendedor = payload?.vendedor || ''
            const personalCargo = payload?.personalCargo || ''
            const ordenPedido = payload?.ordenPedido || ''
            const producto = payload?.producto || ''
            const observaciones = payload?.observaciones || ''
            const rawItems = payload?.items || []

            // Autocompletar campos del form
            this.form.types = 'OUT' // SALIDA
            this.form.oT = ordenPedido
            this.form.numTicket = ordenId
            this.form.numArea = 'EQUIPAMIENTO'
            this.form.project = (producto || '').substring(0, 50)
            this.form.provider = personalCargo
            this.form.nameAuthorized = vendedor
            this.form.categories = 'INSUMO'
            this.form.observations = observaciones

            // Almacén por defecto: CHILLON#2
            const chillon2 = this.custom_warehouses.find(
                (w) => w.description && w.description.toUpperCase().includes('CHILLON') && w.description.includes('#2')
            )
            if (chillon2) {
                this.form.warehouse_id = chillon2.id
            }

            // Parsear items
            let items = rawItems
            if (items.length === 0 && q.items) {
                try {
                    items = typeof q.items === 'string' ? JSON.parse(q.items) : q.items
                } catch (e) {
                    console.error('Error parseando items de query params:', e)
                }
            }

            if (items.length > 0) {
                // Deduplicar por id, sumando cantidades de items duplicados
                const merged = new Map()
                for (const item of items) {
                    if (item == null) continue
                    const key = item.id || item.internal_id || item.codigo || null
                    if (!key) continue

                    const existing = merged.get(key)
                    const qty = Number(item.unidades || item.quantity || 1)

                    if (existing) {
                        existing.quantity += qty
                    } else {
                        merged.set(key, {
                            id: item.id || null,
                            name: item.description || item.descripcion || item.name || '',
                            internal_id: item.internal_id || item.codigo || '',
                            quantity: qty,
                            timestamp: Date.now() + Math.random()
                        })
                    }
                }

                const inventoryItems = Array.from(merged.values())
                this.$store.commit('inventario/UPDATE_LISTA_INVENTORY', inventoryItems)

                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: `Orden #${ordenId}: ${inventoryItems.length} items cargados en inventario`,
                    color: 'success',
                    timeout: 4000
                })
            }

            // NO limpiar query params aquí — se limpian después del envío exitoso
        }
    },

    async created() {
        console.log('warehousesssss', this.custom_warehouses)
        await this.getCustomWarehouses()
        this.loading2 = true

        // Ejecutar ambas promesas en paralelo
        await Promise.all([this.getItemInventory(), this.getLista()])

        this.loading2 = false

        // Autocompletar desde orden de equipamiento
        this.fillFromOrdenEquipamiento()
    }
}
</script>
